import MailService from '@/services/MailService'
import NotionService from '@/services/NotionService'
import config from '@/utils/ApiUtils'
import { fetchWithToken } from '@/utils/Keycloak'

export default {
  state: {
    allContacts: [],
    loadingContacts: false,
    customTemplates: [],
    loadingTemplates: false,
    recipientFilters: [],
    history: [],
    historyTotal: 0,
    historyLoading: false,
    sending: false,
  },

  mutations: {
    setMailAllContacts(state, contacts) {
      state.allContacts = contacts
    },
    setMailLoadingContacts(state, loading) {
      state.loadingContacts = loading
    },
    setMailCustomTemplates(state, templates) {
      state.customTemplates = templates
    },
    setMailLoadingTemplates(state, loading) {
      state.loadingTemplates = loading
    },
    setMailRecipientFilters(state, filters) {
      state.recipientFilters = filters
    },
    setMailHistory(state, { data, total }) {
      state.history = data
      state.historyTotal = total
    },
    setMailHistoryLoading(state, loading) {
      state.historyLoading = loading
    },
    setMailSending(state, sending) {
      state.sending = sending
    },
  },

  actions: {
    loadAllContacts({ commit }, { forceRefresh = false } = {}) {
      commit('setMailLoadingContacts', true)
      const url = config().notionBackend + `contact${forceRefresh ? '?force=true' : ''}`
      return fetchWithToken(url, { method: 'GET' })
        .then(response => response.json())
        .then(contacts => {
          commit('setMailAllContacts', Array.isArray(contacts) ? contacts : [])
          return contacts
        })
        .catch(err => {
          console.error('Error loading all contacts:', err)
          return []
        })
        .finally(() => commit('setMailLoadingContacts', false))
    },

    loadContactsByMagasin({ commit }, magasinPageId) {
      commit('setMailLoadingContacts', true)
      return NotionService.getContacts(magasinPageId)
        .then(contacts => {
          commit('setMailAllContacts', contacts)
          return contacts
        })
        .catch(err => {
          console.error('Error loading magasin contacts:', err)
          return []
        })
        .finally(() => commit('setMailLoadingContacts', false))
    },

    loadCustomTemplates({ commit }) {
      commit('setMailLoadingTemplates', true)
      return MailService.getCustomTemplates()
        .then(templates => {
          commit('setMailCustomTemplates', Array.isArray(templates) ? templates : [])
          return templates
        })
        .catch(err => {
          console.error('Error loading custom templates:', err)
          return []
        })
        .finally(() => commit('setMailLoadingTemplates', false))
    },

    // Le service peut encore répondre 200 avec { error } : on le traite comme un échec
    saveCustomTemplate({ dispatch }, template) {
      return MailService.saveCustomTemplate(template)
        .then(result => {
          if (!result || result.error) throw new Error((result && result.error) || 'Enregistrement impossible')
          dispatch('loadCustomTemplates')
          return result
        })
    },

    deleteCustomTemplate({ dispatch }, templateId) {
      return MailService.deleteCustomTemplate(templateId)
        .then(result => {
          dispatch('loadCustomTemplates')
          return result
        })
    },

    loadMailHistory({ commit }, params = {}) {
      commit('setMailHistoryLoading', true)
      return MailService.getHistory({
        limit: params.limit,
        offset: params.offset,
        search: params.search,
        recipients: params.recipients,
      })
        .then(result => {
          commit('setMailHistory', {
            data: result.data || [],
            total: result.total || 0
          })
          return result
        })
        .catch(err => {
          console.error('Error loading mail history:', err)
          return { data: [], total: 0 }
        })
        .finally(() => commit('setMailHistoryLoading', false))
    },

    loadRecipientFilters({ commit }) {
      return MailService.getRecipientFilters()
        .then(filters => {
          commit('setMailRecipientFilters', Array.isArray(filters) ? filters : [])
          return filters
        })
        .catch(err => {
          console.error('Error loading recipient filters:', err)
          return []
        })
    },

    saveRecipientFilter({ dispatch }, filter) {
      return MailService.saveRecipientFilter(filter)
        .then(result => {
          dispatch('loadRecipientFilters')
          return result
        })
    },

    deleteRecipientFilter({ dispatch }, filterId) {
      return MailService.deleteRecipientFilter(filterId)
        .then(result => {
          dispatch('loadRecipientFilters')
          return result
        })
    },

    sendMail({ commit }, { expediteur, destinataires, contenu, pieceJointe, cc, cci }) {
      commit('setMailSending', true)
      return MailService.sendMail(expediteur, destinataires, contenu, pieceJointe, cc, cci)
        .then(result => result)
        .finally(() => commit('setMailSending', false))
    },
  },
}
